import styled from 'styled-components'
import { useEnsAvatar } from 'wagmi'

import { PrimaryButton } from 'components/core/Buttons'
import { cdnRoot } from 'utils/cdn'
import Link from 'next/link'
import { SubmissionCardProps } from './SubmissionCard'

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 16px 0;
`

const CardDetailsText = styled.div`
  font-size: 18px;
  font-weight: 400;
  margin-top: 16px;
`

const CardNameText = styled.div`
  font-size: 48px;
  font-weight: 700;
  max-width: 80%;
  margin: 8px 0;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    font-size: 32px;
    max-width: 100%;
     
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    font-size: 24px;
  `};
`

const CardDateText = styled.div`
  font-weight: 400;
  font-size: 18px;
  color: #b8bccf;
`

const ArtistImage = styled.img`
  height: 60px;
  width: 60px;
  border-radius: 50%;
  border: 2px solid #080a0c;

  filter: drop-shadow(0px -2px 4px rgba(255, 255, 255, 0.24))
    drop-shadow(0px 8px 16px rgba(27, 26, 37, 0.12))
    drop-shadow(0px 4px 12px rgba(27, 26, 37, 0.08));
`

const ButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: none;
    `};
`

function getTimeAgo(createdAt: number) {
  const date = new Date(createdAt)
  const now = new Date()
  const diff = now.getTime() - date.getTime()
  const diffDays = Math.floor(diff / (1000 * 3600 * 24))
  const diffHours = Math.floor(diff / (1000 * 3600))
  const diffMinutes = Math.floor(diff / (1000 * 60))
  const diffSeconds = Math.floor(diff / 1000)

  let dateText = ''
  if (diffDays > 0) {
    dateText = `${diffDays} days ago`
  } else if (diffHours > 0) {
    dateText = `${diffHours} hours ago`
  } else if (diffMinutes > 0) {
    dateText = `${diffMinutes} minutes ago`
  } else {
    dateText = `${diffSeconds} seconds ago`
  }
  return dateText
}
function SubmissionCardLeft(props: SubmissionCardProps) {
  const { drawingShortId, imgSrc, title, createdAt, displayName } = props

  // const { data: ensAvatar } = useEnsAvatar({ addressOrName: usernameOrAddress })
  const dateText = getTimeAgo(createdAt?.getTime())

  // TODO: Change default profile image.
  const DEFAULT_PROFILE_IMAGE = `${cdnRoot}/images/user-avatar.png`

  return (
    <CardContainer>
      <ArtistImage src={DEFAULT_PROFILE_IMAGE} />
      <CardDetailsText>
        <span style={{ fontWeight: '600' }}>{displayName}</span> submitted
      </CardDetailsText>
      <CardNameText>{title}</CardNameText>
      <CardDateText>{dateText}</CardDateText>
      <div style={{ flexGrow: 1 }} />
      <ButtonsDiv style={{ width: '100%' }}>
        <Link
          passHref={true}
          href={{
            pathname: '/drawing/[shortId]',
            query: {
              shortId: drawingShortId,
            },
          }}
        >
          <PrimaryButton as={'a'} buttonSize="normal" type="button">
            View
          </PrimaryButton>
        </Link>
        {/* <PrimaryButton
          as={'a'}
          buttonSize="normal"
          type="button"
          buttonType="primary_white"
          style={{ width: '35%' }}
        >
          Reject
        </PrimaryButton> */}
      </ButtonsDiv>
    </CardContainer>
  )
}

export default SubmissionCardLeft
